import { createClass as _createClass, classCallCheck as _classCallCheck, defineProperty as _defineProperty } from "../../_virtual/_rollupPluginBabelHelpers.js";
var TransferCost = /* @__PURE__ */ function() {
  function TransferCost2() {
    _classCallCheck(this, TransferCost2);
    _defineProperty(this, "_ttfb", 0);
    _defineProperty(this, "_demuxStart", 0);
    _defineProperty(this, "_demuxEnd", 0);
    _defineProperty(this, "_demuxCost", 0);
    _defineProperty(this, "_remuxStart", 0);
    _defineProperty(this, "_remuxEnd", 0);
    _defineProperty(this, "_remuxCost", 0);
    _defineProperty(this, "_appendStart", 0);
    _defineProperty(this, "_appendEnd", 0);
    _defineProperty(this, "_appendCost", 0);
  }
  _createClass(TransferCost2, [{
    key: "set",
    value: function set(event, value) {
      this["_".concat(event)] = value;
    }
  }, {
    key: "start",
    value: function start(event) {
      this["_".concat(event, "Start")] = Date.now();
    }
  }, {
    key: "end",
    value: function end(event) {
      this["_".concat(event, "End")] = Date.now();
      this["_".concat(event, "Cost")] = this["_".concat(event, "Cost")] + (this["_".concat(event, "End")] - this["_".concat(event, "Start")]);
    }
  }, {
    key: "transferCost",
    get: function get() {
      return {
        ttfbCost: this._ttfb,
        demuxCost: this._demuxCost,
        remuxCost: this._remuxCost,
        appendCost: this._appendCost
      };
    }
  }]);
  return TransferCost2;
}();
var TRANSFER_EVENT = {
  TTFB: "ttfb",
  DEMUX: "demux",
  REMUX: "remux",
  APPEND: "append"
};
export { TRANSFER_EVENT, TransferCost };
